import { Client, JobType, TaskType } from './types';
import env from 'bench-environment';

const openBKToolsRoute = (route: string, clientId: string) => {
  return window.open(`${env.location.bkTools}/${clientId}/${route}`, '_blank');
};

const taskActionLookup: {
  [key in JobType]?: {
    [key in TaskType]?: (clientId: Client['id']) => Window | null;
  };
} = {
  [JobType.RESOLVE_BALANCE_CHECKER]: {
    [TaskType.FIX_BALANCE]: clientId => {
      return openBKToolsRoute('balance-checker', clientId.toString());
    },
    [TaskType.RETRY_FIX_BALANCE]: clientId => {
      return openBKToolsRoute('balance-checker', clientId.toString());
    },
    [TaskType.FIX_BALANCE_FOR_MAPPED_ACCOUNT]: clientId => {
      return openBKToolsRoute('balance-checker', clientId.toString());
    },
  },
  [JobType.RESOLVE_PLAID_CONNECTION]: {
    [TaskType.FIX_BALANCE]: clientId => {
      return openBKToolsRoute('new-accounts', clientId.toString());
    },
    [TaskType.RETRY_FIX_BALANCE]: clientId => {
      return openBKToolsRoute('new-accounts', clientId.toString());
    },
  },
  [JobType.TRIAGE_CLIENT_DOCUMENTS]: {
    [TaskType.TRIAGE_ALL]: clientId => {
      return openBKToolsRoute('upload', clientId.toString());
    },
  },
  [JobType.RESOLVE_DOCUMENT_ADJUSTMENT]: {
    [TaskType.MAKE_ADJUSTMENT]: clientId => {
      return openBKToolsRoute('ledger-accounts?tab=ADDONS', clientId.toString());
    },
  },
  [JobType.RESOLVE_BULK_ADJUSTMENT]: {
    [TaskType.MAKE_BULK_ADJUSTMENT]: clientId => {
      return openBKToolsRoute('ledger-accounts?tab=ADDONS', clientId.toString());
    },
  },
  [JobType.RESOLVE_3RD_PARTY_LOGIN_ADJUSTMENT]: {
    [TaskType.COLLECT_DOCUMENT_AND_MAKE_ADJUSTMENT]: clientId => {
      return openBKToolsRoute('ledger-accounts?tab=ADDONS', clientId.toString());
    },
  },
  [JobType.CATEGORIZE_CLIENT_TRANSACTIONS]: {
    [TaskType.CATEGORIZE_ALL]: clientId => {
      return openBKToolsRoute('details/card', clientId.toString());
    },
    [TaskType.COLLECT_DOCUMENT]: clientId => {
      return openBKToolsRoute('details/card', clientId.toString());
    },
  },
  [JobType.COLLECT_MONTHLY_STATEMENT]: {
    [TaskType.COLLECT_STATEMENT]: clientId => {
      return openBKToolsRoute('balance-checker', clientId.toString());
    },
    [TaskType.RETRY_COLLECT_STATEMENT]: clientId => {
      return openBKToolsRoute('balance-checker', clientId.toString());
    },
  },
  [JobType.COLLECT_ALL_LEDGER_STATEMENTS]: {
    [TaskType.COLLECT_STATEMENTS]: clientId => {
      return openBKToolsRoute('balance-checker', clientId.toString());
    },
    [TaskType.RETRY_COLLECT_STATEMENTS]: clientId => {
      return openBKToolsRoute('balance-checker', clientId.toString());
    },
  },

  [JobType.REVIEW_GENERAL_LEDGER]: {
    [TaskType.REVIEW_CATEGORIZATIONS]: clientId => {
      return openBKToolsRoute('details/card', clientId.toString());
    },
    [TaskType.RESOLVE_INCOMPLETE_BOOKS]: clientId => {
      return openBKToolsRoute('details/card', clientId.toString());
    },
    [TaskType.RETRY_REVIEW_CATEGORIZATIONS]: clientId => {
      return openBKToolsRoute('details/card', clientId.toString());
    },
  },

  [JobType.RESOLVE_INCORRECT_ADJUSTMENT]: {
    [TaskType.FIX_INCORRECT_ADJUSTMENT]: clientId => {
      return openBKToolsRoute('general-ledger', clientId.toString());
    },
  },
  [JobType.RESOLVE_INCORRECT_BALANCE]: {
    [TaskType.FIX_INCORRECT_BALANCE]: clientId => {
      return openBKToolsRoute('balance-checker', clientId.toString());
    },
  },
  [JobType.RESOLVE_INCORRECT_BOOKS]: {
    [TaskType.FIX_REVIEW_TOOL_ISSUES]: clientId => {
      return openBKToolsRoute('review-tool', clientId.toString());
    },
  },
  [JobType.RESOLVE_INCORRECT_CATEGORIZATION]: {
    [TaskType.FIX_INCORRECT_CATEGORIZATION]: clientId => {
      return openBKToolsRoute('general-ledger', clientId.toString());
    },
  },
  [JobType.SETUP_NEW_CONNECTION]: {
    [TaskType.SETUP_AND_CONNECT_LEDGERS]: clientId => {
      return openBKToolsRoute('new-accounts', clientId.toString());
    },
    [TaskType.CONFIRM_CONNECTION_DETAILS]: clientId => {
      return openBKToolsRoute('new-accounts', clientId.toString());
    },
  },
};

const handleNavigateToTaskAction = (
  jobType: JobType,
  taskType: TaskType,
  clientId: Client['id'],
) => {
  const bkNavigatorsByJob = taskActionLookup[jobType];
  const taskBkToolsNavigator = bkNavigatorsByJob !== undefined && bkNavigatorsByJob[taskType];
  if (taskBkToolsNavigator) {
    taskBkToolsNavigator(clientId);
  } else return;
};

const hasTaskAction = (jobType: JobType, taskType: TaskType): boolean => {
  const tasksByJob = taskActionLookup[jobType];
  if (tasksByJob === undefined) return false;
  return Boolean(tasksByJob[taskType]);
};

export { hasTaskAction, handleNavigateToTaskAction, taskActionLookup };
